import { render, staticRenderFns } from "./WithdrawTypeOutput.vue?vue&type=template&id=49a3e972&scoped=true"
import script from "./WithdrawTypeOutput.vue?vue&type=script&lang=js"
export * from "./WithdrawTypeOutput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a3e972",
  null
  
)

export default component.exports